import Component from 'vue-class-component';
import PageRender from '@/models/PageRender';

@Component
export default class BaseInsightsPage extends PageRender {}
